import { EnvironmentConfig } from "~/modules/config";
import { getEnvironmentConfig } from "~/modules/config/EnvironmentConfig/EnvironmentConfigImpl";

export function getTwilioIdpUrl(port?: string): string {
    const envConfig: EnvironmentConfig = getEnvironmentConfig();

    const twilioServiceLoginUrl = envConfig.twilioServiceLoginUrl;
    return port ? `${twilioServiceLoginUrl}?localPort=${port}` : twilioServiceLoginUrl;
}
